import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { kebabCase } from 'lodash';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const parseColorClass = (
  color?: string,
  prefix = 'bg',
  formatColor = true,
) => {
  if (!color) return '';
  return `${prefix}-${formatColor ? kebabCase(color) : color}`;
};
